import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { catchError } from 'rxjs/operators';
import { NavigationExtras, Router } from '@angular/router';


import { User } from '../_models';
import { CookieService } from 'ngx-cookie-service';
import { UserPreferencesService } from '../utils/user-preferences.service';
import { SecurityDocument } from '../shared/models/SecurityDocument';
import { TovpilCookieService } from '../utils/tovpil-cookie.service';
import { environment } from 'src/environments/environment';
import { Constants } from '../shared/vo/Constants';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    /** USER PREFERENCES */
    globalUserPreferences: SecurityDocument = {};

    /** SECURITY */
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient, private apiService: ApiService, private router: Router, private cookieService: CookieService, private userPreferencesService: UserPreferencesService, private cookieServiceTovpil: TovpilCookieService,) {
        if (cookieService.check(Constants.cookie_Name)) {
            let dataB64 = this.cookieService.get(Constants.cookie_Name);
            let dataJson = atob(dataB64);
            this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(dataJson));
            this.currentUser = this.currentUserSubject.asObservable();
        } else {
            this.currentUserSubject = new BehaviorSubject<User>(null);
            this.currentUser = this.currentUserSubject.asObservable();
        }

    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(usernameOrEmail, password) {
        return this.http.post<any>(this.apiService.getLogin(), { usernameOrEmail, password })
            .pipe(
                map(user => {
                    if (user.accessToken != null) {
                        // AL LLAMAR LA FUNCION DIRECTO, REALIZA DOBLE JSON.STRINGFY Y SETEA COOKIE MAL PARSED
                        // SE DEFINIO DOMAIN PARA .TOVPIL EL CUAL NO CONSIDERA AMBIENTES DE DESAROLLO POR ENDE LA COOKIE NO SERA VISIBLE EN LOCALHOST
                        // SE ESTANDARIZA PARA QUE EL BTOA STRINGFY QUEDE EN EL SERVICIO Y EVITAR DOBLE LLAMADA
                        this.cookieServiceTovpil.addObjectCookie(Constants.cookie_Name, user);
                        this.currentUserSubject.next(user);
                    }
                    //this.addToLogin(user);
                    return user;
                }),
                catchError(err => {
                    throw new Error("Error de comunicación, intente mas tarde por favor.");
                })
            )


    }

    logout() {
        // remove user from local storage and set current user to null
        //this.updateToLogout();
        this.cookieService.delete(Constants.cookie_Name)
        this.currentUserSubject.next(null);
        this.router.navigate(['commons/notAvailView'],);
    }


    // NO ELIMINAR: FUNCIONARA CUANDO LA COOKIE DE MONOLITICO SE ORIENTE A RESPONSIVO
    /**
     * The function `addToLogin` handles user preferences by retrieving them from the database and managing
     * cookies accordingly.
     * @param {any} user - The `addToLogin` function takes a `user` object as a parameter. This `user`
     * object is used to retrieve and manage user preferences during the login process. The function
     * performs the following steps:
     */
    async addToLogin(user: any) {
        console.log("entro addToLogin");
        const cookieKey = "userPreferences";
        // ALWAYS WE DELETE COOKIE WHEN LOG IT
        this.cookieServiceTovpil.deleteCookie('userPreferences');
        this.globalUserPreferences = this.cookieServiceTovpil.getObjectCookie('userPreferences') || null;

        try {

            // WE GET USER PREFERENCES FROM DATABASE WHEN LOGGIN INFO
            const userDatabasePreferences = await this.userPreferencesService.getUserPreferences(
                user?.preferences?.userId ?? null, //antonioperez
                user?.preferences?.storeId ?? null, // 00000020
                user?.preferences?.id ?? null, // 65c27ca8c83caf158fd0eabd
                user?.preferences?.language ?? null,
                null,
                user?.preferences?.coordinationId ?? null,
                user?.preferences?.coordinationStack ?? null,
                user?.preferences?.selYear ?? null,
                user?.preferences?.selPeriod ?? null,
                null);

            if (!this.globalUserPreferences && this.globalUserPreferences == null && userDatabasePreferences?.userId == null) {

                // CREAMOS BASE DE DATOS Y COOKIES
                console.debug("Creará cookie con seguridad inicial");
                const response = await this.userPreferencesService.manageCookie(
                    user?.preferences?.userId ?? null, //antonioperez
                    user?.preferences?.storeId ?? null, // 00000020
                    user?.preferences?.id ?? null, // 65c27ca8c83caf158fd0eabd
                    user?.preferences?.language ?? null,
                    null,
                    user?.preferences?.coordinationId ?? null,
                    user?.preferences?.coordinationStack ?? null,
                    user?.preferences?.selYear ?? null,
                    user?.preferences?.selPeriod ?? null,
                    null);
                this.cookieServiceTovpil.addObjectCookie(cookieKey, response, 1);
            } else if (!this.globalUserPreferences && this.globalUserPreferences == null && userDatabasePreferences?.userId != null) {
                // COOKIE NO EXISTE PERO HAY REGISTRO DE PREFERENCIAS
                console.debug("Creará cookie con preferencias de base de datos");
                const responsePreferences = await this.userPreferencesService.manageCookie(
                    userDatabasePreferences?.userId ?? null, // antonioperez
                    userDatabasePreferences?.storeId ?? null, //000023
                    userDatabasePreferences?.id ?? null, //3278h238d38
                    null,
                    null,
                    userDatabasePreferences?.coordinationId ?? null,
                    userDatabasePreferences?.coordinationStack ?? null,
                    null,
                    null,
                    null
                );
                this.cookieServiceTovpil.updateObjectCookie(cookieKey, responsePreferences, 1);
            }
        } catch (error) {
            console.error("An error occurred while navigating:", error);
        }
    }

    /**
     * The function `updateToLogout` asynchronously updates user preferences to logout by managing cookies.
     */
    async updateToLogout() {
        this.globalUserPreferences = this.cookieServiceTovpil.getObjectCookie('userPreferences') || null;
        const cookieKey = "userPreferences";

        try {
            console.debug("Preferencias ", this.globalUserPreferences)
            const stringItms = this.userPreferencesService.coordinationListToString(this.globalUserPreferences?.stores);

            const response = await this.userPreferencesService.manageCookie(
                this.globalUserPreferences.userId ?? null,
                this.globalUserPreferences?.storeId ?? null,
                this.globalUserPreferences?.id ?? null,
                this.globalUserPreferences?.language ?? null,
                this.globalUserPreferences?.selCurrency ?? null,
                this.globalUserPreferences?.coordinationId ?? null,
                stringItms,
                this.globalUserPreferences?.periodSelected?.year ?? null,
                this.globalUserPreferences?.periodSelected?.period ?? null,
                null
            );
            this.cookieServiceTovpil.updateObjectCookie(cookieKey, response, 1);
            this.cookieServiceTovpil.deleteCookie('userPreferences');
        } catch (error) {
            console.error("An error occurred while navigating:", error);
        }
    }
}